import {
    isPluginProduct,
    type ProductCode,
} from '@common/api/productContext';

export type OAuthSuccessPresentation = {
    variant: 'core' | 'plugin';
    showLogout: boolean;
    messageKey: string;
    actionKey: string;
    actionAriaKey: string;
};

export type PluginOAuthSuccessState = 'opening' | 'ready' | 'error';

const CORE_OAUTH_SUCCESS_PRESENTATION: OAuthSuccessPresentation = {
    variant: 'core',
    showLogout: true,
    messageKey: 'website.clientAuth.redirectPrompt',
    actionKey: 'website.clientAuth.openBustly',
    actionAriaKey: 'website.clientAuth.openBustlyAria',
};

const PLUGIN_OAUTH_SUCCESS_PRESENTATION: OAuthSuccessPresentation = {
    variant: 'plugin',
    showLogout: false,
    messageKey: 'website.clientAuth.pluginSuccessMessage',
    actionKey: 'website.clientAuth.openAiApp',
    actionAriaKey: 'website.clientAuth.openAiAppAria',
};

export const resolveOAuthSuccessPresentation = (
    productCode: ProductCode,
): OAuthSuccessPresentation => (
    isPluginProduct(productCode)
        ? PLUGIN_OAUTH_SUCCESS_PRESENTATION
        : CORE_OAUTH_SUCCESS_PRESENTATION
);

export const resolvePluginOAuthSuccessState = ({
    error,
    isLoading,
    redirectUrl,
}: {
    error: string | null;
    isLoading: boolean;
    redirectUrl: string | null;
}): PluginOAuthSuccessState => {
    if (error) {
        return 'error';
    }
    if (isLoading && !redirectUrl) {
        return 'opening';
    }
    return 'ready';
};
